// ForbiddenBanner — shared banner primitive for 403 responses from
// admin write endpoints. Rendered at layout level by AdminLayout so
// every admin page gets the same re-auth guidance without duplicating
// the message in per-form error handling.
//
// Composable: accepts an optional onDismiss callback. Future ToastProvider
// (#36) can wrap this component in a toast slot without changing the
// banner itself.

import { X } from 'lucide-react'

import { Alert } from './alert'

export interface ForbiddenBannerProps {
  onDismiss?: () => void
}

export function ForbiddenBanner({ onDismiss }: ForbiddenBannerProps) {
  return (
    <div className="relative">
      <div className="pr-10">
        <Alert variant="error" title="Permission denied">
          You no longer have permission for this action. Sign out and back
          in to refresh your role.
        </Alert>
      </div>
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss permission warning"
          className="absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded-md text-red-900 hover:bg-red-100"
        >
          <X aria-hidden="true" className="h-4 w-4" />
        </button>
      ) : null}
    </div>
  )
}
